module.exports = __webpack_public_path__ + "img/full4-min.321a970b.png";